/*
 * BookDay Messages
 *
 * This contains all the text for the BookDay component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.BookDay";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Day bookings",
  },
  agenda: {
    id: `${scope}.agenda`,
    defaultMessage: "Agenda",
  },
  subHeader: {
    id: `${scope}.sub-header`,
    defaultMessage: "Click on a date and view the options",
  },
});
